import { QueryClient } from '@tanstack/react-query';

/**
 * Server data lives in TanStack Query (CLAUDE.md / DESIGN §3), never in the
 * Zustand store. One client per browser session.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
